export default function (name, extraProps) {
    if (window.heap) {
        return window.heap.track(name, extraProps || {});
    }
}